import { render } from "./createGroupTraining.html?vue&type=template&id=2c1a641d&scoped=true&ts=true&external"
import script from "./CreateGroupTraining.vue?vue&type=script&lang=ts"
export * from "./CreateGroupTraining.vue?vue&type=script&lang=ts"

import "./CreateGroupTraining.vue?vue&type=style&index=0&id=2c1a641d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1a641d"]])

export default __exports__